import HttpService from '@/api/HttpService';
import { downloadBlob } from '../../util';

export default {
  namespaced: true,
  actions: {
    exportMonthlyMaturitiesReport({ commit }) { // eslint-disable-line no-unused-vars
      return HttpService.getV2('reports/monthly-maturities').then(blob =>
        downloadBlob('monthly_maturities_report.xlsx', blob),
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/monthlyMaturities.js